import { SetFile } from '@bechtel/client-common';
import { Block, CommodityType, WorkPackage } from '@bechtel/types';
import { CreateSingleBlockProps } from '../single';
import { CommodityList } from '../types';

export type CreateMultiBlockProps = {
  workPackageId: WorkPackage['id'];
  commodityTypes?: CommodityType[];
  commoditiesSelected: boolean;
  selectedCommodities: CommodityList[];
  submittedBlocks: Block[];
  onSetFiles: (setFiles: SetFile) => void;
  selectedCommodityTypeId: string;
} & CreateSingleBlockProps;
